<div class="template-placeholders-review" *ngIf="visible">
  <h3 class="text-sm font-bold mb-2">{{ 'dynamicDocument.placeholdersReview.title' | translate }}</h3>
  <p class="text-xs text-gray-500 mb-3">{{ 'dynamicDocument.placeholdersReview.hint' | translate }}</p>

  <div *ngIf="rows.length" class="flex flex-col gap-2 mb-3">
    <div *ngFor="let row of rows" class="flex items-center gap-2 p-2 border rounded">
      <p-checkbox [binary]="true" [(ngModel)]="row.include"></p-checkbox>
      <span class="flex-1 text-sm">{{ row.suggestedName }}</span>
      <span class="text-xs px-2 py-0.5 rounded bg-blue-50 text-blue-700" *ngIf="row.matchedGlobalId">
        {{ 'dynamicDocument.globalVariables.badge' | translate }}
      </span>
      <span class="text-xs text-gray-500" *ngIf="!row.matchedGlobalId">{{ typeLabel(row) | translate }}</span>
    </div>
  </div>

  <div *ngIf="suspicious.length" class="mb-3 p-2 border rounded border-amber-300 bg-amber-50">
    <p class="text-xs font-bold text-amber-700 mb-1">{{ 'dynamicDocument.placeholdersReview.suspiciousTitle' | translate }}</p>
    <p class="text-xs text-amber-700" *ngFor="let s of suspicious">** {{ s }} **</p>
  </div>

  <div class="flex items-center gap-2">
    <button pButton type="button" [label]="'dynamicDocument.placeholdersReview.confirm' | translate" [disabled]="loading" (click)="confirm()"></button>
    <button pButton type="button" class="p-button-text" [label]="'common.cancel' | translate" [disabled]="loading" (click)="dismiss()"></button>
  </div>
</div>
